
import { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { configureAmplify } from "./config/amplify-config";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Pages
import Index from "./pages/Index";
import Clients from "./pages/Clients";
import Sessions from "./pages/Sessions";
import Consultation from "./pages/Consultation";
import Dictation from "./pages/Dictation";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ConfirmSignup from "./pages/ConfirmSignup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import NotFound from "./pages/NotFound";
import Session from "./pages/Session";
import NoteRefinementPage from "./pages/NoteRefinementPage";
import SOAPFormatSettings from "./pages/SOAPFormatSettings";

const queryClient = new QueryClient();
configureAmplify();
const App = () => {

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter basename={import.meta.env.VITE_BASE_URL}>
          <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/confirm-signup" element={<ConfirmSignup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password-confirm" element={<ResetPasswordConfirm />} />
              
              {/* Protected routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Index />} />
                <Route path="/consultation" element={<Consultation />} />
                <Route path="/dictation" element={<Dictation />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/sessions" element={<Sessions />} />
                <Route path="/session" element={<Session />} />
                <Route path="/session/:session_id" element={<Session />} />
                <Route path="/refine-note/:sessionId" element={<NoteRefinementPage />} />
                <Route path="/settings/soap-format" element={<SOAPFormatSettings />} />
              </Route>
              
              {/* Not found route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
